import { render, staticRenderFns } from "./TermsContentOrganisation.vue?vue&type=template&id=2e69642e&scoped=true"
import script from "./TermsContentOrganisation.vue?vue&type=script&lang=js"
export * from "./TermsContentOrganisation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e69642e",
  null
  
)

export default component.exports